"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Looper;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Progress = _interopRequireDefault(require("./Progress"));
function Looper(props) {
  var prefixCls = props.prefixCls,
    _props$percent = props.percent,
    percent = _props$percent === void 0 ? 0 : _props$percent;
  var dotClassName = "".concat(prefixCls, "-dot");
  var holderClassName = "".concat(dotClassName, "-holder");
  var hideClassName = "".concat(holderClassName, "-hidden");
  // ===================== Render =====================
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames["default"])(holderClassName, percent > 0 && hideClassName)
  }, /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
  }, [1, 2, 3, 4].map(function (i) {
    return /*#__PURE__*/React.createElement("i", {
      className: "".concat(prefixCls, "-dot-item"),
      key: i
    });
  }))), /*#__PURE__*/React.createElement(_Progress["default"], {
    prefixCls: prefixCls,
    percent: percent
  }));
}